import emailValidator from 'email-validator';
import { copyFor } from '../../copy/copy';
let parser;

import('parse-address').then(lib => (parser = lib.default));

export const requiredField = value => {
    if (
        value === null ||
        value === '' ||
        value === false ||
        value === undefined ||
        value.length === 0
    ) {
        return copyFor('validationErrors', 'required');
    }
    return;
};

export const validateCountry = values => {
    if (values.countryCode == null || values.countryCode === '') {
        return { countryCode: copyFor('validationErrors', 'country') };
    }
    return {};
};

export const validateEmail = values => {
    if (!emailValidator.validate(values.email)) {
        return { email: copyFor('validationErrors', 'email') };
    }
    return {};
};

export const validatePhone = values => {
    if (
        values.phone == null ||
        values.phone === '' ||
        !values.phone.match(/^(?=.*[0-9])[- +()0-9]+$/) ||
        values.phone.replace(/\D/g, '').length < 7
    ) {
        return { phone: copyFor('validationErrors', 'phone') };
    }
    return {};
};

export const validatePostalCode = values => {
    if (values.postalCode == null || values.postalCode === '') {
        return { postalCode: copyFor('validationErrors', 'postalCode') };
    } else if (values.postalCode.length < 5) {
        return { postalCode: copyFor('validationErrors', 'minLength5') };
    } else if (!values.postalCode.match(/^\d+$/)) {
        return { postalCode: copyFor('validationErrors', 'numbersOnly') };
    }
    return {};
};

export const validateUSPostalCode = values => {
    if (values.postalCode == null || values.postalCode === '') {
        return { postalCode: copyFor('validationErrors', 'postalCode') };
    } else if (values.postalCode.length !== 5) {
        return { postalCode: copyFor('validationErrors', 'minLength5') };
    } else if (!values.postalCode.match(/^\d+$/)) {
        return { postalCode: copyFor('validationErrors', 'numbersOnly') };
    }
    return {};
};

export const validateInternationalPostalCode = values => {
    if (values.postalCode == null || values.postalCode === '') {
        return { postalCode: copyFor('validationErrors', 'postalCode') };
    } else if (values.postalCode.length < 4) {
        return { postalCode: copyFor('validationErrors', 'minLength5') };
    }
    return {};
};

export const validateFirstName = values => {
    if (values.firstName == null || values.firstName === '') {
        return { firstName: copyFor('validationErrors', 'firstName') };
    }
    return {};
};

export const validateMiddleName = values => {
    if (values.firstName == null || values.firstName === '') {
        return { middleName: copyFor('validationErrors', 'middleName') };
    }
    return {};
};

export const validateLastName = values => {
    if (values.lastName == null || values.lastName === '') {
        return { lastName: copyFor('validationErrors', 'lastName') };
    }
    return {};
};

export const validateAddress = values => {
    if (!parser) return {};
    const addressParsed = parser.parseLocation(values.address);
    if (
        values.address == null ||
        values.address === '' ||
        addressParsed.number === undefined ||
        addressParsed.number === '' ||
        addressParsed.street === undefined ||
        addressParsed.street === ''
    ) {
        return { address: copyFor('validationErrors', 'address') };
    }
    return {};
};

export const validatePrefix = values => {
    if (values.prefix == null || values.prefix === '') {
        return { prefix: copyFor('validationErrors', 'prefix') };
    }
    return {};
};

export const validateDay = values => {
    if (values.day == null || values.day === '') {
        return { day: 'Invalid day' };
    }
};
export const validateMonth = values => {
    if (values.month == null || values.month === '') {
        return { month: 'Invalid month' };
    }
};
export const validateYear = values => {
    if (values.year == null || values.year === '') {
        return { year: 'Invalid year' };
    }
};

export const validateCity = values => {
    if (values.homeCity == null || values.homeCity === '') {
        return { homeCity: copyFor('validationErrors', 'city') };
    }
};

export const validateStateId = values => {
    if (values.stateId == null || values.stateId === '') {
        return { stateId: copyFor('validationErrors', 'state') };
    }
};
